// revyou.js — conteúdo da página /apps/revyou.
// As capturas vêm de tools/revyou-capturas: o Revyou web de verdade rodando contra uma API fictícia
// (web e mobile) e as telas do app nativo publicadas pelo próprio produto (app).
// Os membros, as notas e as reviews nas telas são fictícios; os jogos e os filmes são os do catálogo.
import icon from '../assets/revyou/icon.webp';
import webFeed from '../assets/revyou/web/feed.webp';
import webBiblioteca from '../assets/revyou/web/biblioteca.webp';
import webJogo from '../assets/revyou/web/jogo.webp';
import webComunidade from '../assets/revyou/web/jogo-comunidade.webp';
import webAvaliar from '../assets/revyou/web/avaliar.webp';
import webReview from '../assets/revyou/web/review.webp';
import webReviews from '../assets/revyou/web/reviews.webp';
import webPerfil from '../assets/revyou/web/perfil.webp';
import webListas from '../assets/revyou/web/listas.webp';
import webLista from '../assets/revyou/web/lista.webp';
import webTimeline from '../assets/revyou/web/timeline.webp';
import webRecap from '../assets/revyou/web/recap.webp';
import webBusca from '../assets/revyou/web/busca.webp';
import webDescobrir from '../assets/revyou/web/descobrir.webp';
import webFilmes from '../assets/revyou/web/filmes.webp';
import webFilme from '../assets/revyou/web/filme.webp';
import webSteam from '../assets/revyou/web/steam.webp';
import webNotificacoes from '../assets/revyou/web/notificacoes.webp';
import webLanding from '../assets/revyou/web/landing.webp';
import webEmAlta from '../assets/revyou/web/landing-em-alta.webp';
import webJogoPublico from '../assets/revyou/web/jogo-publico.webp';
import mobFeed from '../assets/revyou/mobile/feed.webp';
import mobBiblioteca from '../assets/revyou/mobile/biblioteca.webp';
import mobJogo from '../assets/revyou/mobile/jogo.webp';
import mobPerfil from '../assets/revyou/mobile/perfil.webp';
import mobReview from '../assets/revyou/mobile/review.webp';
import mobLanding from '../assets/revyou/mobile/landing.webp';
import appDescobrir from '../assets/revyou/app/descobrir.webp';
import appFilmes from '../assets/revyou/app/filmes.webp';
import appBusca from '../assets/revyou/app/busca.webp';
import appJogo from '../assets/revyou/app/jogo.webp';
import appFilme from '../assets/revyou/app/filme.webp';
import appRegistrar from '../assets/revyou/app/registrar.webp';

export const ICON = icon;

export const LINKS = {
  site: 'https://www.revyouapp.com/pt',
  appStore: 'https://apps.apple.com/br/app/revyouapp/id6759969254',
  googlePlay: 'https://play.google.com/store/apps/details?id=com.idealizer.revyou&hl=pt_BR',
};

export const HERO_SHOTS = { phone: appJogo, browser: webPerfil };

export const FACTS = [
  { label: 'Plataformas', value: 'Web, iOS e Android' },
  { label: 'Para quem', value: 'Quem joga, assiste e gosta de registrar' },
  { label: 'Catálogo', value: 'Mais de 680 mil jogos e filmes' },
  { label: 'Nosso papel', value: 'Design, web, app e backend' },
];

export const BEFORE = [
  'A biblioteca espalhada entre Steam, PlayStation e Xbox',
  'Lista do que jogar num bloco de notas, ou na cabeça',
  'A opinião sobre um jogo some meses depois de terminar',
  'Recomendação de amigo perdida no meio de um grupo',
  'Nenhum registro de quando começou, terminou ou largou',
];

export const AFTER = [
  'Jogos e filmes num catálogo só, com status para cada um',
  'Backlog e lista de desejos que se montam sozinhos',
  'Nota, curtida e review guardadas com a data',
  'Feed com o que os amigos jogaram, viram e acharam',
  'Linha do tempo e recap do mês, prontos para compartilhar',
];

// Os quatro passos do uso, do primeiro registro ao feed.
export const STEPS = [
  {
    n: '01',
    title: 'Encontre o título',
    desc: 'A busca cobre mais de 320 mil jogos e 360 mil filmes, com capa, ano e estúdio. Também dá para trazer a biblioteca pronta da Steam, da PSN ou do Xbox.',
    img: appBusca,
    alt: 'Busca do app Revyou com resultados para "zelda"',
  },
  {
    n: '02',
    title: 'Registre o que achou',
    desc: 'Um toque no status, a nota em meia estrela, a curtida e a data. Leva menos tempo que mandar uma mensagem.',
    img: appRegistrar,
    alt: 'Tela de registro de um filme no app Revyou, com status, nota e data',
  },
  {
    n: '03',
    title: 'Escreva, se quiser',
    desc: 'A review é opcional e fica ligada à nota, à plataforma e ao tempo de jogo. Quem lê pode curtir, comentar e repostar.',
    img: mobReview,
    alt: 'Review de Clair Obscur: Expedition 33 aberta no Revyou',
  },
  {
    n: '04',
    title: 'Acompanhe os amigos',
    desc: 'O feed mostra o que as pessoas que você segue começaram, terminaram e avaliaram, entre jogos e filmes.',
    img: mobFeed,
    alt: 'Feed do Revyou com reviews e atividades de amigos',
  },
];

// Na web: o lado de quem registra.
export const DIARY_TOUR = [
  {
    id: 'biblioteca',
    title: 'Biblioteca',
    desc: 'Todos os jogos numa grade de capas, filtrados por status, ano ou plataforma. Cada capa leva o selo de onde o jogo veio, a curtida e a platina.',
    img: webBiblioteca,
    alt: 'Biblioteca de jogos no Revyou, em grade de capas com filtros por status',
    url: 'revyouapp.com/pt/u/marina/games',
  },
  {
    id: 'jogo',
    title: 'Página do jogo',
    desc: 'Sinopse, galeria, média da comunidade e, ao lado da capa, a atividade de quem está vendo: nota, status, listas e o botão de atualizar.',
    img: webJogo,
    alt: 'Página de Hollow Knight no Revyou, com a nota da comunidade e a atividade do usuário',
    url: 'revyouapp.com/pt/game/hollow-knight',
  },
  {
    id: 'avaliar',
    title: 'Registrar',
    desc: 'Um painel só para plataforma, tempo de jogo, datas, nota e review. Cada rejogada vira uma entrada nova no histórico, sem apagar a anterior.',
    img: webAvaliar,
    alt: 'Painel de edição de atividade no Revyou, com plataforma, datas, nota e review',
    url: 'revyouapp.com/pt/game/hollow-knight',
  },
  {
    id: 'review',
    title: 'Review',
    desc: 'A review publicada ganha página própria, com a arte do jogo, a nota, o período jogado e os comentários. É ela que vai no link compartilhado.',
    img: webReview,
    alt: 'Página de uma review de Clair Obscur: Expedition 33 no Revyou',
    url: 'revyouapp.com/pt/u/marina/reviews/clair-obscur-expedition-33',
  },
  {
    id: 'reviews',
    title: 'Minhas reviews',
    desc: 'Tudo o que a pessoa já escreveu, de jogos e de filmes, na ordem em que publicou.',
    img: webReviews,
    alt: 'Lista de reviews de uma usuária no Revyou',
    url: 'revyouapp.com/pt/u/marina/reviews',
  },
  {
    id: 'timeline',
    title: 'Linha do tempo',
    desc: 'O diário em ordem: o dia em que cada jogo começou e terminou, e cada filme assistido, mês a mês.',
    img: webTimeline,
    alt: 'Linha do tempo do Revyou, com jogos finalizados e filmes assistidos por mês',
    url: 'revyouapp.com/pt/u/marina/timeline',
  },
  {
    id: 'recap',
    title: 'Recap do mês',
    desc: 'No fim de cada mês o Revyou monta o resumo: o que entrou na biblioteca, o que foi concluído, conquistas e a review mais curtida.',
    img: webRecap,
    alt: 'Recap de setembro de 2026 no Revyou, com jogos adicionados e concluídos',
    url: 'revyouapp.com/pt/recaps/2026-09',
  },
];

// Na web: o lado social.
export const SOCIAL_TOUR = [
  {
    id: 'feed',
    title: 'Feed',
    desc: 'Reviews, jogos começados e listas compartilhadas por quem você segue, com filtro para ver só games ou só filmes.',
    img: webFeed,
    alt: 'Feed do Revyou com a review de um amigo sobre Hollow Knight: Silksong',
    url: 'revyouapp.com/pt/feed',
  },
  {
    id: 'comunidade',
    title: 'Comunidade do jogo',
    desc: 'Em cada título, quais amigos jogaram, que nota deram e as reviews mais curtidas. As dos amigos aparecem primeiro.',
    img: webComunidade,
    alt: 'Aba Comunidade da página de Hollow Knight, com amigos que jogaram e reviews populares',
    url: 'revyouapp.com/pt/game/hollow-knight',
  },
  {
    id: 'perfil',
    title: 'Perfil',
    desc: 'A vitrine de cada pessoa: favoritos em ordem, o que está jogando agora e as listas que escolheu fixar. Cada um monta o seu.',
    img: webPerfil,
    alt: 'Perfil de uma usuária no Revyou, com jogos e filmes favoritos',
    url: 'revyouapp.com/pt/u/marina/profile',
  },
  {
    id: 'listas',
    title: 'Listas',
    desc: 'Backlog e desejos são montados pelo próprio Revyou. As outras são livres: ranqueadas, de checklist ou simples, de jogos ou de filmes.',
    img: webListas,
    alt: 'Listas de uma usuária no Revyou, automáticas e personalizadas',
    url: 'revyouapp.com/pt/u/marina/lists',
  },
  {
    id: 'lista',
    title: 'Lista aberta',
    desc: 'Uma lista ranqueada vista por dentro: capas numeradas, descrição, curtidas e comentários de quem passou por ali.',
    img: webLista,
    alt: 'Lista ranqueada "Metroidvanias essenciais" no Revyou',
    url: 'revyouapp.com/pt/lists/metroidvanias-essenciais',
  },
  {
    id: 'notificacoes',
    title: 'Notificações',
    desc: 'Curtidas, comentários e novos seguidores num lugar só, com link direto para a review ou a lista.',
    img: webNotificacoes,
    alt: 'Notificações do Revyou com curtidas, comentários e novos seguidores',
    url: 'revyouapp.com/pt/notifications',
  },
];

// Descoberta, filmes e importação.
export const DISCOVER_SHOTS = [
  {
    id: 'descobrir',
    title: 'Em destaque',
    desc: 'Rankings atualizados todo dia: em alta, mais bem avaliados, mais jogados, mais platinados, joias escondidas.',
    img: webDescobrir,
    alt: 'Página Em Destaque do Revyou, com o ranking de jogos em alta',
    url: 'revyouapp.com/pt/discover/games',
  },
  {
    id: 'busca',
    title: 'Busca',
    desc: 'Uma busca só para jogos e filmes, com filtros para jogo base, expansão, remake e remaster.',
    img: webBusca,
    alt: 'Busca do Revyou com resultados para "zelda"',
    url: 'revyouapp.com/pt/search?q=zelda',
  },
  {
    id: 'filme',
    title: 'Filmes',
    desc: 'O mesmo diário para o cinema: sinopse em português, direção, elenco e a nota de quem assistiu.',
    img: webFilme,
    alt: 'Página do filme Interestelar no Revyou',
    url: 'revyouapp.com/pt/film/interstellar',
  },
  {
    id: 'steam',
    title: 'Importação',
    desc: 'Com o perfil da Steam, da PSN ou do Xbox conectado, jogos, tempo de jogo e conquistas entram sozinhos e seguem sincronizados.',
    img: webSteam,
    alt: 'Tela de integração com a Steam no Revyou',
    url: 'revyouapp.com/pt/integrations/steam',
  },
];

// App nativo (iOS e Android): capturas do simulador.
export const APP_TOUR = [
  {
    id: 'app-jogo',
    title: 'Página do jogo',
    desc: 'Arte no topo, capa, sinopse e os quatro atalhos de registro logo abaixo do botão Avaliar.',
    img: appJogo,
    alt: 'Página de The Witcher 3 no app Revyou',
  },
  {
    id: 'app-descobrir',
    title: 'Descobrir jogos',
    desc: 'A aba de busca já abre com o que está em alta e o que a comunidade avaliou melhor.',
    img: appDescobrir,
    alt: 'Aba Buscar do app Revyou com jogos em alta e mais bem avaliados',
  },
  {
    id: 'app-busca',
    title: 'Busca',
    desc: 'Resultado em lista, com ano, estúdio e gêneros, para achar a edição certa de primeira.',
    img: appBusca,
    alt: 'Resultados da busca por "zelda" no app Revyou',
  },
  {
    id: 'app-filmes',
    title: 'Filmes',
    desc: 'O mesmo app troca de mídia num toque: vermelho para filmes, roxo para games.',
    img: appFilmes,
    alt: 'Aba Buscar do app Revyou na mídia Filmes',
  },
  {
    id: 'app-filme',
    title: 'Página do filme',
    desc: 'Duração, direção, elenco e trailer, com watchlist e curtida a um toque.',
    img: appFilme,
    alt: 'Página do filme Interestelar no app Revyou',
  },
  {
    id: 'app-registrar',
    title: 'Registrar',
    desc: 'Status, nota, curtida, rewatch e data em uma tela só. A review entra logo abaixo.',
    img: appRegistrar,
    alt: 'Tela Registrar filme do app Revyou',
  },
];

// O site no navegador do celular: mesma conta, mesmos dados, layout próprio.
export const GALLERY = [
  { img: mobFeed, label: 'Feed' },
  { img: mobBiblioteca, label: 'Biblioteca' },
  { img: mobJogo, label: 'Página do jogo' },
  { img: mobReview, label: 'Review' },
  { img: mobPerfil, label: 'Perfil' },
  { img: mobLanding, label: 'Página inicial' },
];

export const LANDING_SHOTS = [
  {
    id: 'landing',
    title: 'Página inicial',
    desc: 'Uma parede de capas, a promessa em três palavras e o tamanho do catálogo contado em tempo real.',
    img: webLanding,
    alt: 'Página inicial do Revyou: Registre. Avalie. Relembre.',
    url: 'revyouapp.com/pt',
  },
  {
    id: 'em-alta',
    title: 'Em alta, sem login',
    desc: 'Rankings, páginas de jogos e reviews são públicos: dá para explorar o Revyou inteiro antes de criar a conta.',
    img: webEmAlta,
    alt: 'Seção Em alta nos games e nos filmes da página inicial do Revyou',
    url: 'revyouapp.com/pt',
  },
  {
    id: 'jogo-publico',
    title: 'Página pública de jogo',
    desc: 'Cada jogo e cada filme tem endereço próprio, que abre sem conta e aparece nos buscadores. Para avaliar, basta entrar.',
    img: webJogoPublico,
    alt: 'Página pública de The Witcher 3 no Revyou, vista por um visitante sem conta',
    url: 'revyouapp.com/pt/game/the-witcher-3-wild-hunt',
  },
  {
    id: 'filmes',
    title: 'Biblioteca de filmes',
    desc: 'Vistos, quero assistir, abandonados e curtidos, na mesma grade de pôsteres da biblioteca de jogos.',
    img: webFilmes,
    alt: 'Biblioteca de filmes de uma usuária no Revyou',
    url: 'revyouapp.com/pt/u/marina/films',
  },
];

// Cores do tema do Revyou (renoir, globals.css) e o papel de cada uma.
export const PALETTE = [
  { name: 'Roxo', hex: '#6E42DD', role: 'Games e ação principal', dark: true },
  { name: 'Vermelho', hex: '#E63946', role: 'Filmes', dark: true },
  { name: 'Rosa', hex: '#F72564', role: 'Curtidas', dark: true },
  { name: 'Ouro', hex: '#FFD700', role: 'Platina e conquistas' },
  { name: 'Grafite', hex: '#1A1A1A', role: 'Cartões e superfícies', dark: true },
  { name: 'Carvão', hex: '#121212', role: 'Fundo das telas', dark: true },
];

export const PRINCIPLES = [
  {
    title: 'A capa é a interface',
    desc: 'Biblioteca, listas, feed e rankings são feitos de capas. O fundo é escuro e neutro para a arte de cada jogo e filme carregar a cor da tela.',
  },
  {
    title: 'Uma cor por mídia',
    desc: 'Roxo é game, vermelho é filme. Estrelas, abas e botões trocam de cor junto, e dá para saber onde se está sem ler nada.',
  },
  {
    title: 'Registrar em segundos',
    desc: 'Status, nota e curtida ficam ao lado da capa, a um clique. A review, as datas e a plataforma são opcionais e moram num painel à parte.',
  },
  {
    title: 'O mesmo produto em três telas',
    desc: 'No computador, a navegação fica na lateral; no celular, vira barra inferior; no app, os mesmos componentes em código nativo.',
  },
];

export const STACK = [
  {
    title: 'Web',
    desc: 'Site e aplicação na mesma base, renderizados no servidor, em português, inglês e espanhol. Páginas de jogos, filmes e reviews são públicas e indexáveis.',
    tags: ['Next.js 16', 'React 19', 'TypeScript', 'Tailwind CSS 4', 'next-intl'],
  },
  {
    title: 'App',
    desc: 'Um código só para iOS e Android, com notificações push, login com Google e Apple e atualização sem passar pela loja.',
    tags: ['React Native', 'Expo', 'NativeWind', 'React Query'],
  },
  {
    title: 'Backend e dados',
    desc: 'API própria para catálogo, perfis, feed, listas e recaps. Metadados de jogos vêm da IGDB e os de filmes, da TheTVDB; as bibliotecas chegam por Steam, PSN e Xbox.',
    tags: ['API REST', 'IGDB', 'TheTVDB', 'Steam', 'PSN', 'Xbox'],
  },
];

export const DELIVERY = [
  'Identidade, design de interface e sistema de design',
  'Site e aplicação web em três idiomas',
  'App para iOS e Android, publicado nas duas lojas',
  'API, catálogo e integrações com Steam, PSN e Xbox',
  'SEO, imagens de compartilhamento e páginas públicas',
  'Evolução contínua: filmes já no ar, séries a caminho',
];
